import React,{useState} from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as authActionCreators from '../../redux/modules/auth';
import pages from '../../constants/pages';
import '../../constants/roles';
import {supportedModules} from "../../constants/utils";
import ModulesMenu from "./modules-menu";
import LanguagesMenu from "./languages-menu";
import Logout from "./logout";
import { withNamespaces } from 'react-i18next';
import people from '../../asset/img/people.svg'
import InfoTooltip from '../common/tooltip/info';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      languageMenu: false,
      modulesMenu: false
    };
    this.handelClick = this.handelClick.bind(this);
    this.getPageName = this.getPageName.bind(this);
    this.viewToggle = this.viewToggle.bind(this);
  }
  
  handelClick(menuTitle) {
    if(menuTitle === 'language'){
      this.setState((prev) => ({
        languageMenu: !prev.languageMenu,
        modulesMenu:false  
      }))
    } else if (menuTitle === 'modules') {
      this.setState((prev) => ({
        modulesMenu: !prev.modulesMenu,
        languageMenu:false  
      }))
    }
  }
  getPageName() {
    const { activePath ,t} = this.props;

    const activePage = pages.find(page => activePath.startsWith(page.path));

    if (activePage) {
      return t(activePage.title);
    }

    return t("home"); // OR config.app.title
  }

  viewToggle() {
    const { auth, toggleEmployeeView, t } = this.props;

    if (auth.user && (auth.user.role.some(r => r !== 'EMPLOYEE'))
            && auth.employeeView === false) {
      return (
        
    
          <Link to="/" onClick={toggleEmployeeView}>
              <InfoTooltip info={t('switchToEmployeeView')} placement="bottom">
            <button type="button" className="logout-button">        
              <i>                
                <img src={people} className="languages-icon" style={{width:"30px", height:"30px"}}/>
              </i>
            </button>  
            </InfoTooltip>
          </Link>  
           
      );
    }

    if (auth.user && auth.user.role.some(r => r !== 'EMPLOYEE')
            && auth.employeeView === true) {
      return (
      
         
          <Link to="/" onClick={toggleEmployeeView}>
            <InfoTooltip info={t('switchToManagerView')} placement="bottom">
            <button type="button" className="logout-button">        
              <i>
                <img src={people} className="languages-icon" style={{width:"30px", height:"30px"}}/>
              </i>
            </button> 
            </InfoTooltip>  
          </Link>  
         
      );
    }

    return null;
  }

  render() {
      const { auth } = this.props;
      const authorities = auth.user.authorities || [];
    return (
      <nav className="navbar navbar-default">
        <div className="container-fluid">
          <div className="navbar-header">
          <button type="button" className="navbar-toggle">
              <span className="sr-only">
              Toggle navigation
              </span>
              <span className="icon-bar bar1" />
              <span className="icon-bar bar2" />
              <span className="icon-bar bar3" />
            </button>
            <span className="navbar-brand">
              {this.getPageName()}
            </span>
              <div className="hidden-lg-up" style={{width:'200px', float:'right'}}>
                <ModulesMenu authorities={authorities} handelClick={this.handelClick} isModuleMenuOpen = {this.state.modulesMenu}  />
                <LanguagesMenu handelClick={this.handelClick} isLanguageMenuOpen = {this.state.languageMenu}/>
                {this.viewToggle()}
              </div>
          </div>
            <div className="collapse navbar-collapse">
                <div className="hidden-lg-down">                 
                    <Logout />
                    <ModulesMenu authorities={authorities} handelClick={this.handelClick} isModuleMenuOpen = {this.state.modulesMenu} />
                    <LanguagesMenu handelClick={this.handelClick} isLanguageMenuOpen = {this.state.languageMenu}/>
                    {this.viewToggle()}
                </div>           
          </div>
        </div>
      </nav>
    );
  }
}

const mapStateToProps = state => ({
  activePath: state.routing.location.pathname,
  auth: state.auth,
});

const mapDispatchToProps = dispatch => bindActionCreators(authActionCreators,
  dispatch);

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(Header));



// WEBPACK FOOTER //
// ./src/components/header/index.js